<div
  class="container_notification"
  [class]="{
    container_notification_error: data.status === 'ERROR',
    container_notification_success: data.status === 'SUCCESS',
    container_notification_info: data.status === 'INFO',
    container_notification_warning: data.status === 'WARNING'
  }"
>
  <div class="box_btn_and_notifie">
    <div class="icon_self">
      <img class="icon_true" [src]="alertIcon()" alt="" />
    </div>
    <div [class]="data.status !== 'SUCCESS' ? 'place_texts' : 'place_texts_success'">
      <p [class]="data.status !== 'SUCCESS' ? 'text_notie1' : 'text_notie1_success'">
        <span class="span_toast">{{ data.message }}</span>
      </p>
    </div>
  </div>
  <div class="btn_close_notie" (click)="closeToast()">
    <img src="../../../assets/icones/close.svg" alt="Close" />
  </div>
</div>
